var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskMaintenanceGeneral = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.587 2.036a.4.4 0 0 1 .108-.033v-.001a.32.32 0 0 1 .26.091l.951.954a.32.32 0 0 1 .061.366l-1.589 3.175a.32.32 0 0 1-.283.176h-1.139L14.83 11.13l-1.718-1.72 4.127-4.365V3.906c0-.121.07-.23.176-.284zm-12.075 10.3a.32.32 0 0 1 .45 0l2.538 2.54a.32.32 0 0 1 0 .447l-.728.728-2.989-2.987zm-4.884 5.049 3.708-3.873 2.987 2.988-3.707 3.872c-.861.86-2.236.912-3.068.08s-.781-2.206.08-3.067m1.51-15.067h-.001zm5.178 1.106a4.87 4.87 0 0 0-5.178-1.106l2.516 2.516c.782.78.782 2.037 0 2.819a1.99 1.99 0 0 1-2.82 0L2.32 5.137a4.87 4.87 0 0 0 6.51 6.197l9.274 9.274a1.77 1.77 0 0 0 2.506 0 1.77 1.77 0 0 0 0-2.506l-9.275-9.274a4.88 4.88 0 0 0-1.018-5.404",
  clipRule: "evenodd"
})));
export default SvgTaskMaintenanceGeneral;